import { render, staticRenderFns } from "./DatePoint.vue?vue&type=template&id=87e81b08&"
import script from "./DatePoint.vue?vue&type=script&lang=js&"
export * from "./DatePoint.vue?vue&type=script&lang=js&"
import style0 from "./DatePoint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports